<tcs-splash-screen></tcs-splash-screen>
<div fxLayout="column" class="app-layout">
  <div
    *ngIf="environment !== 'prod'"
    class="environment-banner {{ environment }}"
    title="{{ environmentDisplay }} environment"
    fxFlex="20px"
  >
    {{ environmentDisplay }}
  </div>
  <div class="app-content" fxFlex><router-outlet> </router-outlet></div>
</div>

<pre class="display-none">
<!-- Used for debugging purposes, do not remove --> 
{{
  clientInfo | json
}}
</pre>
